var _path, _rect, _rect2, _rect3, _rect4, _path2, _rect5, _rect6, _rect7, _rect8, _path3, _rect9, _rect10, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAgreementServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 206,
    viewBox: "0 0 205 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8672 96.3418L81.2169 89.8305C83.6499 89.3694 86.0344 90.8346 86.7221 93.2135L93.3027 115.976C95.1439 122.345 92.1247 129.114 86.1556 131.998L56.3562 146.4L46.8672 96.3418Z",
    fill: "#EEC2B9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 42.5654,
    y: 92.1484,
    width: 64.1887,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 42.5654 92.1484)",
    fill: "#FFDCD5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.6719,
    y: 101.109,
    width: 61.9498,
    height: 11.6202,
    rx: 4.8,
    transform: "rotate(33.2866 36.6719 101.109)",
    fill: "#FFDCD5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 30.2871,
    y: 110.817,
    width: 57.0675,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 30.2871 110.817)",
    fill: "#FFDCD5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3936,
    y: 119.778,
    width: 54.2998,
    height: 10.7263,
    rx: 4.8,
    transform: "rotate(33.2866 24.3936 119.778)",
    fill: "#FFDCD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8199 91.6011C36.3105 89.3373 39.3787 88.7559 41.5942 90.3174L62.4382 105.009C64.5567 106.502 65.1072 109.407 63.6819 111.572L44.4796 140.735C42.989 142.999 39.9208 143.58 37.7053 142.019L16.8613 127.327C14.7428 125.834 14.1923 122.929 15.6176 120.764L34.8199 91.6011Z",
    fill: "#FFDCD5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.8867,
    y: 131.924,
    width: 9.83245,
    height: 17.6989,
    rx: 3.2,
    transform: "rotate(33.0034 34.8867 131.924)",
    fill: "#EEC2B9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7021,
    y: 126.478,
    width: 9.83245,
    height: 14.3017,
    rx: 3.2,
    transform: "rotate(33.0034 26.7021 126.478)",
    fill: "#EEC2B9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 51.2578,
    y: 142.819,
    width: 9.83245,
    height: 12.9079,
    rx: 3.2,
    transform: "rotate(33.0034 51.2578 142.819)",
    fill: "#EEC2B9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0713,
    y: 137.372,
    width: 9.83245,
    height: 15.3009,
    rx: 3.2,
    transform: "rotate(33.0034 43.0713 137.372)",
    fill: "#EEC2B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1769 96.8502L68.3826 92.2619L63.2994 103.4L48.6974 106.001L43.2781 115.827C41.7292 118.636 38.3408 119.864 35.352 118.7L34.9656 118.55C33.7247 118.067 33.1144 116.666 33.6056 115.428L39.4202 100.777C40.2287 98.7402 42.0235 97.2584 44.1769 96.8502Z",
    fill: "#EEC2B9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2939,
    y: 82.5693,
    width: 151.444,
    height: 51.6776,
    rx: 3.2,
    transform: "rotate(-18.9457 79.2939 82.5693)",
    fill: "#374969"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 19.6649,
    height: 51.6776,
    rx: 3.2,
    transform: "matrix(-0.818407 -0.574639 -0.574639 0.818407 45.8896 87.6787)",
    fill: "#F5F5F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 107.826,
    cy: 119.913,
    r: 2.71164,
    transform: "rotate(31.7203 107.826 119.913)",
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 116.857,
    cy: 117.132,
    r: 2.71164,
    transform: "rotate(31.7203 116.857 117.132)",
    fill: "#D9D9D9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAgreementServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcAgreementServiceBody2Mobile.ccc552c3c8085847070ce8218e9a5906.svg";
export { ForwardRef as ReactComponent };